module.exports = __webpack_public_path__ + "img/lux_trust_mobile.fb56e358.svg";